import {
	Show,
	Hide,
	Flex,
	Text,
	Stack,
	Image,
	Heading,
	SimpleGrid,
} from "@chakra-ui/react";

import { RateTag } from "../components/RateTag";
import { Extra } from "../components/Extra";

import polaroids from "../media/polaroids.jpg";
import preen from "../media/preen.jpg";
import fling from "../media/fling.jpg";
import view from "../media/view.jpg";

export const Compensation = () => {
	return (
		<Stack
			id="compensation"
			pt={{ base: "4", md: "8" }}
			gap={{ base: "2", md: "8" }}
		>
			<Flex gap="8" align="center">
				<Stack
					gap="6"
					justify="space-between"
					pb={{ base: "4", md: "0" }}
					px={{ base: "4", md: "0" }}
					w={{ base: "auto", md: "60%" }}
				>
					<Heading fontSize="xl">WORTH EVERY PENNY</Heading>
					<Text>
						Whether it’s a lunch time rendezvous or an evening of debauchery,
						you’ll be in for a delightfully sensual experience.
					</Text>
					<Stack gap="4">
						<RateTag label="LUNCHTIME FLING" rate="1 hour | $1000" />
						<RateTag label="AFTERNOON DELIGHT" rate="2 hours | $1800" />
						<RateTag label="EVENING RENDEZVOUS" rate="3 hours | $2400" />
						<RateTag label="DINNER & A SHOW" rate="4 hours | $3000" />
					</Stack>{" "}
				</Stack>

				<Show above="md">
					<Image
						w="40%"
						h="300px"
						src={view}
						rounded="3"
						alt="experience"
						objectFit="cover"
						onContextMenu={(e) => e.preventDefault()}
					/>
				</Show>
			</Flex>

			<SimpleGrid
				h="100%"
				gap={{ base: "2", md: "8" }}
				columns={{ base: 1, md: 2 }}
			>
				<Extra alt="incall" image={fling}>
					<Stack>
						<Text>
							I can meet you at your choice of 5 star hotel in Melbourne CBD.
							Alternatively, for a small donation I can host you at one of my
							favourite hotels.
						</Text>
						<Text>
							Take control or leave it to me to take care of you. Either way
							you’ll be in for a treat.
						</Text>
					</Stack>
					<RateTag label="INCALL" rate="+$200" />
				</Extra>

				<Extra alt="polaroids" image={polaroids}>
					<Stack>
						<Text>
							Want to document the experience?
							<br />I can bring my Polaroid camera so you can take home some
							intimate keepsakes.
						</Text>
						<Text>
							We can take as many as you like so have a think about any shots in
							particular you might like to capture ahead of time. I may have a
							few suggestions if you need some inspiration.
						</Text>
					</Stack>
					<RateTag label="POLAROIDS" rate="+$100" />
				</Extra>

				<Hide>
					<Extra alt="panties" image={fling}>
						<Stack>
							<Text>
								If you want something a little more tangible to remember the
								experience by, why not take my panties home with you so you can
								savour the memory as long as you like.
							</Text>
							<Text>
								Let’s leave them on while we’re playing and we can get them nice
								and juicy. Plus, afterwards you’ll have the additional thrill of
								knowing I’m out on the town with no panties on.
							</Text>
						</Stack>
						<RateTag label="PANTIES" rate="+$100" />
					</Extra>
				</Hide>
			</SimpleGrid>

			<Image
				w="100%"
				src={preen}
				alt="experience"
				objectFit="cover"
				rounded={{ base: "0", md: "3" }}
				h={{ base: "300px", md: "390px" }}
				onContextMenu={(e) => e.preventDefault()}
			/>
		</Stack>
	);
};
